export default "__VITE_ASSET__BKCWFrzt__"